module.exports = __webpack_public_path__ + "static/media/listIconPoi3.aaa32aa0.svg";